import { FC, ReactNode } from "react";

interface SubGroupPanelProps {
  title?: string;
  description?: string;
  accent?: boolean;
  className?: string;
  children: ReactNode;
}

export const SubGroupPanel: FC<SubGroupPanelProps> = ({
  title,
  description,
  accent = true,
  className = "",
  children,
}) => {
  const isParticipantSubsection = className.includes(
    "blanket-participant-subsection",
  );

  return (
    <div
      role="group"
      className={`rounded border p-4 ${
        isParticipantSubsection ? "" : "bg-white"
      } ${accent ? "border-start border-4 border-primary" : ""} ${className}`.trim()}
    >
      {title || description ? (
        <div className="mb-3">
          {title ? <p className="fw-semibold mb-0">{title}</p> : null}
          {description ? (
            <p className="small text-muted mb-0 mt-1">{description}</p>
          ) : null}
        </div>
      ) : null}
      {children}
    </div>
  );
};

export default SubGroupPanel;
